module.exports = __webpack_public_path__ + "img/p4000.0ad3a39e.png";